import connectionTypes from '../../consts/connectionTypes';
import {IAP_FEATURES_CODES} from '../../consts/iap/iapFeatureCodes';
import featuresService from '../../services/features/featuresService';
import selectDeviceConfig from '../selectDeviceConfig';

const getIsEnabled = (featureCode, deviceType, connectionType) =>
    featuresService.getIsFeatureEnabled(featureCode, deviceType, connectionType);

const getIsAboutDeviceEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.ABOUT_DEVICE, deviceType);
const getIsAdvancedDiagnosticEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC, deviceType);
const getIsAdvancedDiagnosticPhase2Enabled = (deviceType) =>
    getIsEnabled(IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC_PHASE_2, deviceType);
const getIsAppearanceEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.APPEARANCE, deviceType);
const getIsAutoStartEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.AUTO_START, deviceType);
const getIsConnectivityEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.CONNECTIVITY, deviceType);
const getIsDashboardEnabled = () => getIsEnabled(IAP_FEATURES_CODES.DASHBOARD);
const getIsDeviceLockEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.DEVICE_LOCK, deviceType);
const getIsExperienceScoreEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.EXPERIENCE_SCORE, deviceType);
const getIsFlexBatteryEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.FLEX_BATTERY, deviceType);
const getIsFlexPuffEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.FLEX_PUFF, deviceType);
const getIsLedIntensityEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.LED_INTENSITY, deviceType);
const getIsPauseModeEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.PAUSE_MODE, deviceType);
const getIsSmartGesturesEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.SMART_GESTURES, deviceType);
const getIsSoftwareUpdateEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.SOFTWARE_UPDATE, deviceType);
const getIsSwitchMasterEnabled = () => getIsEnabled(IAP_FEATURES_CODES.SWITCH_MASTER_BADGE);
const getIsTipsAndTutorialsEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.TIPS_AND_TUTORIALS, deviceType);
const getIsUsageEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.USAGE, deviceType);
const getIsVibrationsEnabled = (deviceType) => getIsEnabled(IAP_FEATURES_CODES.VIBRATION, deviceType);

// WiFi and LTE setup share the SETUP code (the model tells them apart); Sidewalk is gated on its own.
const SETUP_FLOW_FEATURE_CODES = {
    [connectionTypes.WIFI]: IAP_FEATURES_CODES.SETUP,
    [connectionTypes.CELLULAR]: IAP_FEATURES_CODES.SETUP,
    [connectionTypes.SIDEWALK]: IAP_FEATURES_CODES.SIDEWALK,
};

const getIsSetupFlowEnabled = (deviceType, connectionType) => {
    const setupFeatureCode = SETUP_FLOW_FEATURE_CODES[connectionType];

    if (!setupFeatureCode) return false;

    return getIsEnabled(setupFeatureCode, deviceType, connectionType);
};

const getIsAnySetupFlowEnabled = () =>
    selectDeviceConfig.some(({deviceType, connectionType}) => getIsSetupFlowEnabled(deviceType, connectionType));

const configSettingGetters = {
    getIsAboutDeviceEnabled,
    getIsAdvancedDiagnosticEnabled,
    getIsAdvancedDiagnosticPhase2Enabled,
    getIsAppearanceEnabled,
    getIsAutoStartEnabled,
    getIsConnectivityEnabled,
    getIsDashboardEnabled,
    getIsDeviceLockEnabled,
    getIsExperienceScoreEnabled,
    getIsFlexBatteryEnabled,
    getIsFlexPuffEnabled,
    getIsLedIntensityEnabled,
    getIsPauseModeEnabled,
    getIsSmartGesturesEnabled,
    getIsSoftwareUpdateEnabled,
    getIsSwitchMasterEnabled,
    getIsTipsAndTutorialsEnabled,
    getIsUsageEnabled,
    getIsVibrationsEnabled,
    getIsAnySetupFlowEnabled,
    getIsSetupFlowEnabled,
};

export default configSettingGetters;
